export const stringFormat = (template: string, ...args: string[]) => {
  return template.replace(/{(\d+)}/g, (match, number) => (typeof args[number] != 'undefined' ? args[number] : match))
}
